import { combineReducers } from 'redux'

import redirect from './redirect.reducer'
import config from './config.reducer'
import score from './score.reducer'
import notification from './notification.reducer'
import socket from './socket.reducer'
import lead from './lead.reducer'

const rootReducer = combineReducers({
  redirect,
  config,
  score,
  notification,
  socket,
  lead
})

export default rootReducer
